import { Link } from "react-router-dom";

export const Logo = ({ className = "" }) => (
  <Link to="/" className={`flex items-center ${className}`} data-testid="brand-logo-link">
    <img src="/brand/iosegnalo-logo-orizzontale.svg" alt="iosegnalo.net" className="h-11 w-auto md:h-14" data-testid="brand-logo-img" />
  </Link>
);
